import styles from "./styles.module.scss";
import img1 from "./img/1.png";
import img2 from "./img/2.png";
import img3 from "./img/3.png";
import img4 from "./img/4.png";
import img5 from "./img/5.png";

import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const data = [
  {
    value: "Slow and steady ",
    displayValue: "Slow and steady ",
    emoji: img1,
  },
  {
    value: "Moderate",
    displayValue: "Moderate",
    emoji: img2,
  },
  {
    value: "Fast",
    displayValue: "Fast",
    emoji: img3,
  },
  {
    value: "Mixed",
    displayValue: "Mixed",
    emoji: img4,
  },
  {
    value: "I want Walky to decide",
    displayValue: "I want Walky to decide",
    emoji: img5,
  },
];
export const AchiveYourGoal = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(WALKY_KEYS.achiveYourGoal, v.points);
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>What pace would you like to achieve your goal at?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.points}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
